export default __webpack_public_path__ + "static/media/vengeanceismine.a030aedf.png";